// extracted by mini-css-extract-plugin
export var headingImage = "heading-image-module--heading-image--2et7J";
export var imageWrapper = "heading-image-module--image-wrapper--3u9te";